var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import PhotoFrame from '../../Photo/PhotoFrame';
import ResizedPhoto from '../../Photo/ResizedPhoto';
import SimplePhotoListActions from './SimplePhotoListActions';
import Warning from '../../../components/Warning';
import { updateSelectedPhoto, updateSelectedProductItem } from '../store/actions';
var mapDispatchToProps = {
    updateSelectedPhoto: updateSelectedPhoto,
    updateSelectedProductItem: updateSelectedProductItem,
};
var connector = connect(null, mapDispatchToProps);
var SimplePhotoList = /** @class */ (function (_super) {
    __extends(SimplePhotoList, _super);
    function SimplePhotoList(props) {
        var _this = _super.call(this, props) || this;
        _this.wrapperElement = null;
        _this.resizeEventListener = null;
        _this.debouncedWrapperSizeUpdate = null;
        _this.isResizing = false;
        _this.state = {
            activeItemId: null,
            isResizing: false,
            wrapperWidth: null,
            wrapperHeight: null,
        };
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        return _this;
    }
    SimplePhotoList.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('resize', this.handleWindowResize);
        this.debouncedWrapperSizeUpdate = debounce(function () {
            _this.isResizing = false;
            _this.updateWrapperSizes();
        }, 500);
    };
    SimplePhotoList.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleWindowResize);
    };
    SimplePhotoList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "c-simple-photo-list__wrapper" },
            React.createElement("div", { ref: function (element) { return _this.setWrapperElementRef(element); }, className: "c-simple-photo-list" }, this.props.photos.map(function (item) { return _this.renderItem(item); }))));
    };
    SimplePhotoList.prototype.renderItem = function (item) {
        var _this = this;
        var dpi = item.getDpi();
        return (React.createElement("div", { key: item.id, className: "c-simple-photo-list__item", onClick: function () {
                if (_this.state.activeItemId === item.id) {
                    return;
                }
                _this.setState({ activeItemId: item.id });
            }, onMouseEnter: function () { return _this.updateActiveItem(item); }, onMouseLeave: function () { return _this.setState({ activeItemId: null }); } },
            React.createElement(PhotoFrame, { photo: item, crop: true, shadow: true },
                React.createElement(ResizedPhoto, { photo: item })),
            this.state.activeItemId === item.id &&
                React.createElement(SimplePhotoListActions, { cartItem: this.props.cartItem, photo: item }),
            dpi && dpi < 150 && (React.createElement("div", { className: "c-simple-photo-list__warning" },
                React.createElement(Warning, { title: "warnings.low_image_quality.title" })))));
    };
    SimplePhotoList.prototype.handleWindowResize = function () {
        if (!this.isResizing) {
            this.isResizing = true;
            this.setState({ isResizing: true });
        }
        if (this.debouncedWrapperSizeUpdate) {
            this.debouncedWrapperSizeUpdate();
        }
    };
    SimplePhotoList.prototype.setWrapperElementRef = function (element) {
        if (this.wrapperElement) {
            return;
        }
        this.wrapperElement = element;
        this.updateWrapperSizes();
    };
    SimplePhotoList.prototype.updateWrapperSizes = function () {
        if (!this.wrapperElement) {
            return;
        }
        var wrapperWidth = this.wrapperElement.clientWidth;
        var wrapperHeight = this.wrapperElement.clientHeight;
        if (wrapperWidth === this.state.wrapperWidth && wrapperHeight === this.state.wrapperHeight) {
            return;
        }
        this.setState({ wrapperWidth: wrapperWidth, wrapperHeight: wrapperHeight, isResizing: false });
    };
    SimplePhotoList.prototype.updateActiveItem = function (item) {
        var _this = this;
        var _a;
        if (item.id === this.state.activeItemId) {
            return;
        }
        this.props.updateSelectedPhoto(item);
        this.props.updateSelectedProductItem((_a = item === null || item === void 0 ? void 0 : item.product_item) !== null && _a !== void 0 ? _a : null);
        // do the setState after the next cycle so the first click wont affect the component
        window.setTimeout(function () {
            _this.setState({ activeItemId: item.id });
        }, 0);
    };
    return SimplePhotoList;
}(React.Component));
export default connector(withTranslation()(SimplePhotoList));
